var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.839,
    height: 192.704,
    viewBox: "0 0 243.839 192.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(0 -22.028)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(0 213.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M262.021,452.893c0,.079-53.066.142-118.51.142-65.467,0-118.521-.063-118.521-.142s53.054-.142,118.521-.142C208.955,452.751,262.021,452.815,262.021,452.893Z",
    transform: "translate(-24.99 -452.751)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(62.561 2.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(0 19.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(0.127 0.118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 138.917,
    height: 154.747,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M139.858,65.4,278.776,65.3h.118V65.4c.007,44.211.015,97.465.024,154.762v.139h-.142l-138.917-.013h-.128v-.113c.076-91.977.126-153.787.127-154.776,0,.988.052,62.8.128,154.776l-.127-.113,138.917-.013-.142.126v-.014c.009-57.3.017-110.551.024-154.762l.118.1Z",
    transform: "translate(-139.731 -65.299)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(10.502 34.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M163.671,133.649v.4h-3.105V129.66h3.011v.4H161.03v1.562H163.3v.4H161.03v1.631Z",
    transform: "translate(-160.566 -129.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M173.532,133.027v1.914h-.445v-1.87c0-.7-.351-1.054-.947-1.054a1.061,1.061,0,0,0-1.1,1.192v1.732h-.445v-1.87c0-.7-.351-1.054-.954-1.054a1.064,1.064,0,0,0-1.1,1.192v1.732h-.445v-3.3h.426v.6a1.335,1.335,0,0,1,1.21-.627,1.186,1.186,0,0,1,1.173.7,1.437,1.437,0,0,1,1.3-.7A1.245,1.245,0,0,1,173.532,133.027Z",
    transform: "translate(-163.986 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M182.548,132.9v2.045h-.426v-.515a1.24,1.24,0,0,1-1.136.546c-.746,0-1.2-.389-1.2-.96,0-.508.326-.935,1.274-.935H182.1v-.2c0-.565-.32-.872-.935-.872a1.678,1.678,0,0,0-1.1.389l-.2-.333a2.1,2.1,0,0,1,1.342-.445A1.172,1.172,0,0,1,182.548,132.9Zm-.445,1.054v-.539h-1.035c-.64,0-.847.251-.847.589,0,.383.307.621.834.621A1.055,1.055,0,0,0,182.1,133.95Z",
    transform: "translate(-169.304 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M186.888,129.491a.322.322,0,0,1,.326-.314.316.316,0,0,1,.327.307.326.326,0,0,1-.653.007Zm.1,1.041h.445v3.3h-.445Z",
    transform: "translate(-172.536 -129.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M190.166,129.177h.445v4.655h-.445Z",
    transform: "translate(-174.027 -129.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M198.532,132.9v2.045h-.426v-.515a1.239,1.239,0,0,1-1.135.546c-.746,0-1.2-.389-1.2-.96,0-.508.326-.935,1.273-.935h1.048v-.2c0-.565-.32-.872-.935-.872a1.679,1.679,0,0,0-1.1.389l-.2-.333a2.094,2.094,0,0,1,1.342-.445A1.172,1.172,0,0,1,198.532,132.9Zm-.445,1.054v-.539h-1.035c-.64,0-.847.251-.847.589,0,.383.307.621.834.621A1.056,1.056,0,0,0,198.087,133.95Z",
    transform: "translate(-176.574 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M205.814,129.177v4.655h-.427v-.653a1.43,1.43,0,0,1-1.274.684,1.678,1.678,0,0,1,0-3.356,1.442,1.442,0,0,1,1.255.652v-1.982Zm-.439,3a1.228,1.228,0,1,0-1.223,1.286A1.207,1.207,0,0,0,205.374,132.182Z",
    transform: "translate(-179.623 -129.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M213.611,129.177v4.655h-.427v-.653a1.43,1.43,0,0,1-1.274.684,1.678,1.678,0,0,1,0-3.356,1.442,1.442,0,0,1,1.255.652v-1.982Zm-.439,3a1.228,1.228,0,1,0-1.223,1.286A1.207,1.207,0,0,0,213.171,132.182Z",
    transform: "translate(-183.168 -129.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M220.335,131.616v.433c-.038,0-.075-.007-.107-.007a1.067,1.067,0,0,0-1.11,1.217v1.681h-.445v-3.3h.427v.646A1.244,1.244,0,0,1,220.335,131.616Z",
    transform: "translate(-186.991 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M225.731,133.429h-2.76a1.221,1.221,0,0,0,1.3,1.148,1.3,1.3,0,0,0,1.01-.432l.251.288a1.745,1.745,0,0,1-3-1.142,1.589,1.589,0,0,1,1.612-1.675,1.572,1.572,0,0,1,1.6,1.675C225.738,133.329,225.731,133.379,225.731,133.429Zm-2.76-.333h2.34a1.172,1.172,0,0,0-2.34,0Z",
    transform: "translate(-188.743 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M229.241,134.564l.2-.351a1.992,1.992,0,0,0,1.173.37c.627,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.54.464-.941,1.3-.941a2.239,2.239,0,0,1,1.167.308l-.195.357a1.691,1.691,0,0,0-.972-.282c-.6,0-.86.232-.86.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,229.241,134.564Z",
    transform: "translate(-191.797 -130.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M234.865,134.564l.2-.351a1.991,1.991,0,0,0,1.173.37c.628,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.54.465-.941,1.3-.941a2.236,2.236,0,0,1,1.167.308l-.195.357a1.689,1.689,0,0,0-.972-.282c-.6,0-.859.232-.859.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,234.865,134.564Z",
    transform: "translate(-194.355 -130.286)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(5.818 13.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M172.867,157.747h-2.76a1.222,1.222,0,0,0,1.3,1.148,1.3,1.3,0,0,0,1.01-.433l.251.288a1.744,1.744,0,0,1-3-1.142,1.589,1.589,0,0,1,1.612-1.675,1.572,1.572,0,0,1,1.6,1.675C172.874,157.647,172.867,157.7,172.867,157.747Zm-2.76-.332h2.34a1.172,1.172,0,0,0-2.34,0Z",
    transform: "translate(-169.662 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M178.728,159.28l-1.048-1.38-1.054,1.38h-.5l1.3-1.693-1.242-1.606h.5l.991,1.292.991-1.292h.489l-1.241,1.606,1.317,1.693Z",
    transform: "translate(-172.601 -154.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M185.332,157.214v2.045h-.426v-.514a1.24,1.24,0,0,1-1.136.546c-.746,0-1.2-.389-1.2-.96,0-.508.326-.935,1.273-.935h1.048v-.2c0-.565-.32-.872-.935-.872a1.682,1.682,0,0,0-1.1.389l-.2-.333a2.1,2.1,0,0,1,1.342-.445A1.172,1.172,0,0,1,185.332,157.214Zm-.445,1.053v-.539h-1.035c-.64,0-.847.251-.847.59,0,.382.308.62.834.62A1.056,1.056,0,0,0,184.886,158.268Z",
    transform: "translate(-175.53 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M195.3,157.346v1.913h-.445v-1.87c0-.7-.351-1.053-.947-1.053a1.06,1.06,0,0,0-1.1,1.192v1.731h-.445v-1.87c0-.7-.351-1.053-.953-1.053a1.063,1.063,0,0,0-1.1,1.192v1.731h-.445v-3.3h.426v.6a1.335,1.335,0,0,1,1.211-.628,1.185,1.185,0,0,1,1.173.7,1.437,1.437,0,0,1,1.3-.7A1.245,1.245,0,0,1,195.3,157.346Z",
    transform: "translate(-178.846 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M205.4,157.609a1.6,1.6,0,0,1-1.643,1.682,1.441,1.441,0,0,1-1.255-.653v1.838h-.445v-4.517h.426v.653a1.437,1.437,0,0,1,1.274-.678A1.6,1.6,0,0,1,205.4,157.609Zm-.445,0a1.231,1.231,0,1,0-1.23,1.286A1.215,1.215,0,0,0,204.955,157.609Z",
    transform: "translate(-184.394 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M209.854,153.495h.445v4.655h-.445Z",
    transform: "translate(-187.94 -153.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M215.542,157.747h-2.76a1.222,1.222,0,0,0,1.3,1.148,1.3,1.3,0,0,0,1.01-.433l.251.288a1.744,1.744,0,0,1-3-1.142,1.589,1.589,0,0,1,1.612-1.675,1.572,1.572,0,0,1,1.6,1.675C215.549,157.647,215.542,157.7,215.542,157.747Zm-2.76-.332h2.34a1.172,1.172,0,0,0-2.34,0Z",
    transform: "translate(-189.069 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M225.186,156.676c0,1.066-.4,1.694-1.041,1.694a.669.669,0,0,1-.709-.684,1.4,1.4,0,0,1-1.255.684,1.62,1.62,0,0,1,0-3.237,1.4,1.4,0,0,1,1.242.659v-.634h.408v2.377c0,.351.176.477.389.477.389,0,.64-.483.64-1.33a2.393,2.393,0,0,0-2.578-2.453,2.522,2.522,0,1,0-.025,5.043,2.768,2.768,0,0,0,1.2-.276l.107.308a3.058,3.058,0,0,1-1.311.288,2.842,2.842,0,1,1,.025-5.683A2.712,2.712,0,0,1,225.186,156.676Zm-1.756.069a1.2,1.2,0,1,0-1.192,1.261A1.169,1.169,0,0,0,223.43,156.745Z",
    transform: "translate(-192.259 -153.684)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M234.551,155.959v2.9a1.448,1.448,0,0,1-1.65,1.65,2.3,2.3,0,0,1-1.537-.508l.226-.339a1.964,1.964,0,0,0,1.3.452c.834,0,1.217-.383,1.217-1.2v-.42a1.485,1.485,0,0,1-1.286.64,1.6,1.6,0,1,1,0-3.2,1.49,1.49,0,0,1,1.3.659v-.634Zm-.433,1.569a1.252,1.252,0,1,0-1.255,1.21A1.18,1.18,0,0,0,234.118,157.528Z",
    transform: "translate(-197.631 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M245.106,157.346v1.913h-.445v-1.87c0-.7-.352-1.053-.948-1.053a1.061,1.061,0,0,0-1.1,1.192v1.731h-.445v-1.87c0-.7-.351-1.053-.954-1.053a1.063,1.063,0,0,0-1.1,1.192v1.731h-.445v-3.3h.426v.6a1.335,1.335,0,0,1,1.211-.628,1.186,1.186,0,0,1,1.173.7,1.436,1.436,0,0,1,1.3-.7A1.245,1.245,0,0,1,245.106,157.346Z",
    transform: "translate(-201.495 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M254.123,157.214v2.045H253.7v-.514a1.239,1.239,0,0,1-1.135.546c-.746,0-1.2-.389-1.2-.96,0-.508.327-.935,1.274-.935h1.047v-.2c0-.565-.32-.872-.935-.872a1.681,1.681,0,0,0-1.1.389l-.2-.333a2.1,2.1,0,0,1,1.342-.445A1.172,1.172,0,0,1,254.123,157.214Zm-.445,1.053v-.539h-1.035c-.64,0-.846.251-.846.59,0,.382.307.62.834.62A1.055,1.055,0,0,0,253.677,158.268Z",
    transform: "translate(-206.814 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M258.463,153.809a.322.322,0,0,1,.326-.314.317.317,0,0,1,.327.308.326.326,0,0,1-.653.007Zm.1,1.041h.445v3.3h-.445Z",
    transform: "translate(-210.046 -153.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M261.74,153.495h.445v4.655h-.445Z",
    transform: "translate(-211.536 -153.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M264.3,161.174a.333.333,0,0,1,.333-.339.338.338,0,0,1,.339.339.343.343,0,0,1-.339.345A.338.338,0,0,1,264.3,161.174Z",
    transform: "translate(-212.702 -156.833)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M266.49,157.609a1.624,1.624,0,0,1,1.7-1.675,1.442,1.442,0,0,1,1.292.653l-.333.226a1.121,1.121,0,0,0-.96-.489,1.287,1.287,0,0,0,0,2.572,1.116,1.116,0,0,0,.96-.483l.333.226a1.454,1.454,0,0,1-1.292.653A1.629,1.629,0,0,1,266.49,157.609Z",
    transform: "translate(-213.696 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M272.861,157.609a1.678,1.678,0,1,1,1.681,1.682A1.623,1.623,0,0,1,272.861,157.609Zm2.9,0a1.228,1.228,0,1,0-1.223,1.286A1.2,1.2,0,0,0,275.765,157.609Z",
    transform: "translate(-216.594 -154.604)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M286.125,157.346v1.913h-.445v-1.87c0-.7-.351-1.053-.947-1.053a1.061,1.061,0,0,0-1.1,1.192v1.731h-.445v-1.87c0-.7-.351-1.053-.954-1.053a1.063,1.063,0,0,0-1.1,1.192v1.731h-.446v-3.3h.426v.6a1.335,1.335,0,0,1,1.211-.628,1.186,1.186,0,0,1,1.173.7,1.437,1.437,0,0,1,1.3-.7A1.245,1.245,0,0,1,286.125,157.346Z",
    transform: "translate(-220.149 -154.604)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(0 8.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M276.122,160.175a.938.938,0,0,0,.606-.257c.4-.307.232-1.048.262-1.906-.006-1.759-.015-4.343-.027-7.67q0-1.249-.006-2.636,0-.347,0-.7a2.676,2.676,0,0,0-.043-.694.838.838,0,0,0-.441-.495,1.631,1.631,0,0,0-.712-.077l-6.592.012-16.072.021-93.059.041a.756.756,0,0,0-.616.312,1.067,1.067,0,0,0-.144.73v5.073q0,3.365,0,6.685c.006.265-.014.58.013.8a.754.754,0,0,0,.4.537.769.769,0,0,0,.335.081h11l24.708.009,41.837.03,28.205.045,7.668.027,1.994.014c.449,0,.68.015.68.015s-.231.009-.68.014l-1.994.014-7.668.027-28.205.045-41.837.03-24.708.009h-11a1.052,1.052,0,0,1-.461-.11,1.038,1.038,0,0,1-.556-.738c-.036-.326-.01-.566-.018-.854q0-3.319,0-6.685v-5.073a3.624,3.624,0,0,1,.014-.445,1.011,1.011,0,0,1,.185-.451,1.042,1.042,0,0,1,.846-.429l93.059.041,16.072.021,6.592.011a1.739,1.739,0,0,1,.767.092.966.966,0,0,1,.508.575,2.714,2.714,0,0,1,.046.733q0,.355,0,.7,0,1.386-.007,2.636c-.011,3.326-.021,5.911-.027,7.67q0,.656-.007,1.158a.945.945,0,0,1-.292.769A.827.827,0,0,1,276.122,160.175Z",
    transform: "translate(-158.992 -145.531)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(10.502 67.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(0.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M164,191.581c0,.935-.677,1.5-1.794,1.5H161.03v1.387h-.464v-4.391h1.643C163.326,190.076,164,190.641,164,191.581Zm-.464,0c0-.7-.464-1.1-1.342-1.1H161.03v2.2H162.2C163.075,192.673,163.539,192.272,163.539,191.581Z",
    transform: "translate(-160.566 -189.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M170.738,193.312v2.045h-.426v-.515a1.24,1.24,0,0,1-1.136.546c-.746,0-1.2-.389-1.2-.96,0-.508.326-.935,1.274-.935h1.047v-.2c0-.565-.32-.872-.935-.872a1.678,1.678,0,0,0-1.1.389l-.2-.333a2.094,2.094,0,0,1,1.342-.445A1.172,1.172,0,0,1,170.738,193.312Zm-.445,1.054v-.539h-1.035c-.64,0-.847.251-.847.589,0,.383.308.621.835.621A1.055,1.055,0,0,0,170.292,194.366Z",
    transform: "translate(-163.934 -190.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M174.422,194.98l.2-.351a1.99,1.99,0,0,0,1.173.37c.627,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.54.464-.941,1.3-.941a2.237,2.237,0,0,1,1.167.307l-.195.357a1.691,1.691,0,0,0-.972-.282c-.6,0-.859.232-.859.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,174.422,194.98Z",
    transform: "translate(-166.867 -190.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M180.046,194.98l.2-.351a1.992,1.992,0,0,0,1.173.37c.627,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.54.465-.941,1.3-.941a2.236,2.236,0,0,1,1.167.307l-.194.357a1.692,1.692,0,0,0-.973-.282c-.6,0-.859.232-.859.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,180.046,194.98Z",
    transform: "translate(-169.425 -190.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M190.761,192.078l-1.249,3.3h-.42l-1.041-2.7-1.041,2.7h-.42l-1.242-3.3h.426l1.035,2.8,1.06-2.8h.383l1.054,2.8,1.047-2.8Z",
    transform: "translate(-171.836 -190.723)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M195.72,193.707a1.678,1.678,0,1,1,1.681,1.681A1.623,1.623,0,0,1,195.72,193.707Zm2.9,0a1.228,1.228,0,1,0-1.223,1.286A1.2,1.2,0,0,0,198.624,193.707Z",
    transform: "translate(-176.553 -190.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M205.2,192.032v.433c-.038,0-.075-.007-.107-.007a1.067,1.067,0,0,0-1.11,1.217v1.682h-.445v-3.3h.426v.646A1.245,1.245,0,0,1,205.2,192.032Z",
    transform: "translate(-180.109 -190.702)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M210.736,189.593v4.655h-.427V193.6a1.43,1.43,0,0,1-1.274.684,1.678,1.678,0,0,1,0-3.356,1.442,1.442,0,0,1,1.255.652v-1.982Zm-.439,3a1.228,1.228,0,1,0-1.223,1.286A1.207,1.207,0,0,0,210.3,192.6Z",
    transform: "translate(-181.861 -189.593)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(6.244 13.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M173.55,219.144v.4h-3.106v-4.391h3.011v.4h-2.547v1.562h2.271v.4h-2.271v1.631Z",
    transform: "translate(-170.444 -214.891)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M181,218.522v1.913h-.445v-1.87a.921.921,0,0,0-.991-1.053,1.082,1.082,0,0,0-1.154,1.192v1.731h-.445v-3.3h.427v.608a1.386,1.386,0,0,1,1.254-.634A1.263,1.263,0,0,1,181,218.522Z",
    transform: "translate(-173.864 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M187.059,219.653a1.062,1.062,0,0,1-.7.232.874.874,0,0,1-.966-.96v-1.994h-.589v-.377h.589v-.721h.445v.721h1v.377h-1V218.9a.529.529,0,0,0,.571.6.737.737,0,0,0,.489-.17Z",
    transform: "translate(-176.976 -215.199)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M192.8,218.923h-2.76a1.221,1.221,0,0,0,1.3,1.148,1.3,1.3,0,0,0,1.01-.432l.251.288a1.745,1.745,0,0,1-3-1.142,1.589,1.589,0,0,1,1.612-1.675,1.572,1.572,0,0,1,1.6,1.675C192.8,218.823,192.8,218.873,192.8,218.923Zm-2.76-.333h2.34a1.172,1.172,0,0,0-2.34,0Z",
    transform: "translate(-179.151 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M198.809,217.11v.433c-.038,0-.075-.007-.106-.007a1.068,1.068,0,0,0-1.111,1.217v1.682h-.445v-3.3h.426v.646A1.244,1.244,0,0,1,198.809,217.11Z",
    transform: "translate(-182.588 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M208.114,218.785a1.6,1.6,0,0,1-1.644,1.681,1.441,1.441,0,0,1-1.255-.652v1.838h-.445v-4.517h.426v.653a1.436,1.436,0,0,1,1.273-.678A1.6,1.6,0,0,1,208.114,218.785Zm-.445,0a1.231,1.231,0,1,0-1.229,1.286A1.215,1.215,0,0,0,207.669,218.785Z",
    transform: "translate(-186.055 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M214.794,218.39v2.045h-.427v-.514a1.238,1.238,0,0,1-1.135.545c-.746,0-1.2-.389-1.2-.96,0-.508.326-.935,1.273-.935h1.048v-.2c0-.565-.32-.872-.935-.872a1.679,1.679,0,0,0-1.1.389l-.2-.333a2.1,2.1,0,0,1,1.342-.445A1.172,1.172,0,0,1,214.794,218.39Zm-.445,1.054V218.9h-1.035c-.64,0-.847.251-.847.589,0,.383.308.621.834.621A1.056,1.056,0,0,0,214.348,219.444Z",
    transform: "translate(-189.355 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M218.478,220.058l.2-.351a1.992,1.992,0,0,0,1.173.37c.627,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.539.465-.941,1.3-.941a2.239,2.239,0,0,1,1.167.308l-.195.357a1.692,1.692,0,0,0-.973-.282c-.6,0-.859.232-.859.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,218.478,220.058Z",
    transform: "translate(-192.288 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M224.1,220.058l.2-.351a1.991,1.991,0,0,0,1.173.37c.628,0,.884-.213.884-.539,0-.859-2.139-.182-2.139-1.487,0-.539.464-.941,1.3-.941a2.236,2.236,0,0,1,1.167.308l-.194.357a1.693,1.693,0,0,0-.973-.282c-.6,0-.859.232-.859.546,0,.891,2.139.22,2.139,1.486,0,.571-.5.941-1.361.941A2.2,2.2,0,0,1,224.1,220.058Z",
    transform: "translate(-194.846 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M234.817,217.156l-1.249,3.3h-.42l-1.041-2.7-1.041,2.7h-.42l-1.242-3.3h.426l1.035,2.8,1.06-2.8h.383l1.053,2.8,1.048-2.8Z",
    transform: "translate(-197.257 -215.801)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M239.776,218.785a1.678,1.678,0,1,1,1.681,1.681A1.623,1.623,0,0,1,239.776,218.785Zm2.9,0a1.228,1.228,0,1,0-1.223,1.286A1.2,1.2,0,0,0,242.68,218.785Z",
    transform: "translate(-201.974 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M249.258,217.11v.433c-.038,0-.075-.007-.107-.007a1.067,1.067,0,0,0-1.11,1.217v1.682H247.6v-3.3h.427v.646A1.244,1.244,0,0,1,249.258,217.11Z",
    transform: "translate(-205.53 -215.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M254.792,214.671v4.655h-.427v-.653a1.43,1.43,0,0,1-1.274.684,1.678,1.678,0,0,1,0-3.356,1.44,1.44,0,0,1,1.255.653v-1.982Zm-.439,3a1.228,1.228,0,1,0-1.223,1.286A1.206,1.206,0,0,0,254.352,217.676Z",
    transform: "translate(-207.282 -214.671)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(90.057 13.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M324.628,215.555v1.726H326.9v.4h-2.271v1.863h-.464v-4.391h3.011v.4Z",
    transform: "translate(-324.164 -215.116)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M330.454,218.785a1.678,1.678,0,1,1,1.681,1.681A1.623,1.623,0,0,1,330.454,218.785Zm2.9,0a1.228,1.228,0,1,0-1.224,1.286A1.2,1.2,0,0,0,333.358,218.785Z",
    transform: "translate(-327.025 -216.006)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M339.936,217.11v.433c-.038,0-.075-.007-.106-.007a1.068,1.068,0,0,0-1.111,1.217v1.682h-.445v-3.3h.426v.646A1.246,1.246,0,0,1,339.936,217.11Z",
    transform: "translate(-330.581 -216.006)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M345.514,217.135v2.9a1.447,1.447,0,0,1-1.65,1.649,2.3,2.3,0,0,1-1.536-.508l.226-.339a1.962,1.962,0,0,0,1.3.452c.834,0,1.216-.383,1.216-1.2v-.42a1.484,1.484,0,0,1-1.286.64,1.6,1.6,0,1,1,0-3.2,1.49,1.49,0,0,1,1.3.659v-.634Zm-.433,1.569a1.252,1.252,0,1,0-1.254,1.21A1.179,1.179,0,0,0,345.081,218.7Z",
    transform: "translate(-332.333 -216.006)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M350.015,218.785a1.678,1.678,0,1,1,1.681,1.681A1.623,1.623,0,0,1,350.015,218.785Zm2.9,0a1.228,1.228,0,1,0-1.224,1.286A1.2,1.2,0,0,0,352.919,218.785Z",
    transform: "translate(-335.92 -216.006)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M359.143,219.653a1.063,1.063,0,0,1-.7.232.874.874,0,0,1-.966-.96v-1.994h-.59v-.377h.59v-.721h.445v.721h1v.377h-1V218.9a.529.529,0,0,0,.571.6.738.738,0,0,0,.489-.17Z",
    transform: "translate(-339.047 -215.425)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M363.848,216.246c0-.452-.37-.766-1.01-.766a1.458,1.458,0,0,0-1.2.508l-.333-.251a1.916,1.916,0,0,1,1.562-.653c.878,0,1.443.42,1.443,1.092,0,1.073-1.148,1.123-1.148,2.02H362.7C362.7,217.161,363.848,217.067,363.848,216.246Zm-1.242,2.973a.329.329,0,0,1,.659,0,.329.329,0,0,1-.659,0Z",
    transform: "translate(-341.055 -215.085)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(0 9.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M276.122,221.351a.938.938,0,0,0,.606-.257c.4-.308.232-1.048.262-1.906-.006-1.759-.015-4.343-.027-7.669q0-1.25-.006-2.636,0-.346,0-.7a2.68,2.68,0,0,0-.043-.694.838.838,0,0,0-.441-.495,1.631,1.631,0,0,0-.712-.077l-6.592.012-16.072.021-93.059.042a.757.757,0,0,0-.616.312,1.069,1.069,0,0,0-.144.73v5.072q0,3.365,0,6.685c.006.265-.014.58.013.8a.756.756,0,0,0,.4.537.768.768,0,0,0,.335.08h4.518l6.482,0,24.708.008,41.837.031,28.205.045,7.668.027,1.994.014c.449,0,.68.015.68.015s-.231.01-.68.014l-1.994.014-7.668.027-28.205.045-41.837.031-24.708.008h-11a1.039,1.039,0,0,1-1.017-.848c-.036-.326-.01-.566-.018-.854q0-3.319,0-6.685v-5.072a3.636,3.636,0,0,1,.014-.446,1.009,1.009,0,0,1,.185-.451,1.041,1.041,0,0,1,.846-.429l93.059.041,16.072.021,6.592.011a1.747,1.747,0,0,1,.767.092.967.967,0,0,1,.508.575,2.717,2.717,0,0,1,.046.734q0,.355,0,.7,0,1.386-.007,2.636c-.011,3.326-.021,5.91-.027,7.669,0,.437,0,.824-.007,1.158a.944.944,0,0,1-.292.769A.827.827,0,0,1,276.122,221.351Z",
    transform: "translate(-158.992 -206.707)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(10.502 135.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(47.272 4.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M245.692,326.731l.182-.358a2.158,2.158,0,0,0,1.449.533c.822,0,1.179-.345,1.179-.777,0-1.2-2.7-.464-2.7-2.089,0-.646.5-1.2,1.618-1.2a2.478,2.478,0,0,1,1.361.389l-.157.37a2.264,2.264,0,0,0-1.2-.364c-.8,0-1.16.357-1.16.8,0,1.2,2.7.477,2.7,2.076,0,.647-.514,1.2-1.637,1.2A2.384,2.384,0,0,1,245.692,326.731Z",
    transform: "translate(-245.692 -322.609)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M253.179,322.734a.322.322,0,0,1,.326-.314.317.317,0,1,1,0,.634A.323.323,0,0,1,253.179,322.734Zm.1,1.042h.445v3.3h-.445Z",
    transform: "translate(-249.097 -322.421)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M259.492,326.273v1.913h-.445v-1.869a.921.921,0,0,0-.991-1.054,1.082,1.082,0,0,0-1.154,1.192v1.731h-.445v-3.3h.426v.608a1.387,1.387,0,0,1,1.255-.634A1.263,1.263,0,0,1,259.492,326.273Z",
    transform: "translate(-250.587 -323.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M267.043,324.886v2.9a1.448,1.448,0,0,1-1.65,1.649,2.3,2.3,0,0,1-1.536-.508l.226-.339a1.966,1.966,0,0,0,1.3.451c.834,0,1.216-.382,1.216-1.2v-.42a1.483,1.483,0,0,1-1.286.64,1.6,1.6,0,1,1,0-3.2,1.49,1.49,0,0,1,1.305.659v-.634Zm-.433,1.568a1.252,1.252,0,1,0-1.255,1.21A1.18,1.18,0,0,0,266.61,326.454Z",
    transform: "translate(-253.861 -323.531)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M278.113,324.907v3.3h-.427v-.6a1.312,1.312,0,0,1-1.185.634,1.279,1.279,0,0,1-1.393-1.418v-1.913h.445v1.869a.924.924,0,0,0,.991,1.06,1.073,1.073,0,0,0,1.123-1.2v-1.731Z",
    transform: "translate(-259.069 -323.552)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M286.249,326.536a1.6,1.6,0,0,1-1.644,1.681,1.441,1.441,0,0,1-1.255-.652V329.4H282.9v-4.517h.426v.652a1.438,1.438,0,0,1,1.274-.677A1.6,1.6,0,0,1,286.249,326.536Zm-.446,0a1.23,1.23,0,1,0-1.229,1.286A1.215,1.215,0,0,0,285.8,326.536Z",
    transform: "translate(-262.615 -323.531)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M276.122,328.662a.938.938,0,0,0,.606-.257c.4-.307.232-1.048.262-1.906-.006-1.759-.015-4.343-.027-7.669q0-1.249-.006-2.636,0-.347,0-.7a2.68,2.68,0,0,0-.043-.694.84.84,0,0,0-.441-.495,1.631,1.631,0,0,0-.712-.076l-6.592.011-16.072.021-93.059.041a.757.757,0,0,0-.616.312,1.07,1.07,0,0,0-.144.73v5.073q0,3.365,0,6.685c.006.264-.014.579.013.8a.756.756,0,0,0,.74.617h11l24.708.008,41.837.031,28.205.045,7.668.027,1.994.014c.449,0,.68.015.68.015s-.231.01-.68.015l-1.994.014-7.668.027-28.205.045-41.837.031-24.708.008h-11a1.039,1.039,0,0,1-1.017-.848c-.036-.326-.01-.566-.018-.853q0-3.319,0-6.685v-5.073a3.636,3.636,0,0,1,.014-.446,1.012,1.012,0,0,1,.185-.451,1.043,1.043,0,0,1,.846-.429l93.059.041,16.072.021,6.592.011a1.74,1.74,0,0,1,.767.093.966.966,0,0,1,.508.574,2.717,2.717,0,0,1,.046.734q0,.355,0,.7,0,1.385-.007,2.636c-.011,3.326-.021,5.91-.027,7.669q0,.657-.007,1.158a.946.946,0,0,1-.292.77A.827.827,0,0,1,276.122,328.662Z",
    transform: "translate(-158.992 -314.018)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(10.645 108.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 117.883,
    height: 14.502,
    rx: 7.251,
    fill: "#3a9cd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(49.932 4.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M250.833,273.291h.464v3.99h2.46v.4h-2.924Z",
    transform: "translate(-250.833 -273.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M256.732,276.923a1.678,1.678,0,1,1,1.681,1.681A1.623,1.623,0,0,1,256.732,276.923Zm2.9,0a1.228,1.228,0,1,0-1.224,1.286A1.2,1.2,0,0,0,259.636,276.923Z",
    transform: "translate(-253.516 -273.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M267.331,275.272v2.9a1.448,1.448,0,0,1-1.65,1.649,2.3,2.3,0,0,1-1.536-.508l.226-.339a1.962,1.962,0,0,0,1.3.451c.834,0,1.216-.382,1.216-1.2v-.42a1.485,1.485,0,0,1-1.286.64,1.6,1.6,0,1,1,0-3.2,1.49,1.49,0,0,1,1.305.659v-.634Zm-.433,1.568a1.252,1.252,0,1,0-1.255,1.211A1.18,1.18,0,0,0,266.9,276.84Z",
    transform: "translate(-256.795 -273.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M275.27,273.122a.322.322,0,0,1,.326-.314.316.316,0,0,1,.326.308.326.326,0,0,1-.652.006Zm.1,1.041h.445v3.3h-.445Z",
    transform: "translate(-261.946 -272.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M281.583,276.659v1.913h-.445V276.7a.921.921,0,0,0-.991-1.053,1.081,1.081,0,0,0-1.154,1.191v1.732h-.446v-3.3h.427v.608a1.387,1.387,0,0,1,1.255-.634A1.263,1.263,0,0,1,281.583,276.659Z",
    transform: "translate(-263.436 -273.917)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(9.079 36.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(1.895 170.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(0.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M46.012,440.825l-.707,4.01.6.132c2.659.563,13.559,2.674,15.436,2.407,2.093-.3-5.878-3.432-5.878-3.432l.25-1.694Z",
    transform: "translate(-45.305 -440.825)",
    fill: "#3a9cd8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(0.032 1.157)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M48.867,446.268a3.411,3.411,0,0,0-.92-2.263,3.313,3.313,0,0,0-2.163-1.057l-.421,2.716Z",
    transform: "translate(-45.363 -442.947)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(0.103 3.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M59.332,448.783s2.765,1.281,2.331,1.7-11.53-1.3-16.358-2.485l.05-.215L58.279,449.9S58.763,448.719,59.332,448.783Z",
    transform: "translate(-45.305 -447.786)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(0 3.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M45.117,447.731a.939.939,0,0,0,.165.044l.475.1,1.754.349c1.484.285,3.539.651,5.816,1.006s4.348.63,5.847.81l1.778.2.484.046a.94.94,0,0,0,.17.008.863.863,0,0,0-.167-.032l-.481-.068-1.773-.238c-1.5-.2-3.563-.49-5.839-.845s-4.332-.707-5.819-.971l-1.761-.312-.48-.081A.9.9,0,0,0,45.117,447.731Z",
    transform: "translate(-45.117 -447.73)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(13.043 4.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M69.047,450.792a4.072,4.072,0,0,1,.461-.792,3.978,3.978,0,0,1,.707-.583,1.588,1.588,0,0,0-1.168,1.375Z",
    transform: "translate(-69.039 -449.413)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(10.406 3.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M64.205,447.849c.025.022.188-.124.364-.325s.3-.382.274-.4-.188.124-.364.326S64.18,447.828,64.205,447.849Z",
    transform: "translate(-64.202 -447.118)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(9.685 3.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M62.882,447.092c.018.027.187-.051.378-.176s.331-.248.313-.275-.188.051-.378.176S62.864,447.064,62.882,447.092Z",
    transform: "translate(-62.88 -446.636)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(9.331 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M62.231,445.634a2.25,2.25,0,1,0,.517.026A1.171,1.171,0,0,0,62.231,445.634Z",
    transform: "translate(-62.231 -445.616)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    transform: "translate(9.26 1.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M62.1,444.409a1.443,1.443,0,0,0,1.136.265,3.145,3.145,0,0,0-.569-.129A3.2,3.2,0,0,0,62.1,444.409Z",
    transform: "translate(-62.101 -444.403)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(10.87 2.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M65.053,446.418a1.821,1.821,0,0,0,.625.093,3.633,3.633,0,0,0,.688-.044,1.849,1.849,0,0,0,.4-.1.341.341,0,0,0,.185-.17.248.248,0,0,0-.056-.264,1.159,1.159,0,0,0-1.468.115,1.125,1.125,0,0,0-.268.385.35.35,0,0,0-.043.166,1.783,1.783,0,0,1,.367-.489,1.145,1.145,0,0,1,.587-.264.981.981,0,0,1,.737.166c.088.089.031.2-.089.248a1.926,1.926,0,0,1-.375.1,4.359,4.359,0,0,1-.669.068C65.294,446.435,65.056,446.4,65.053,446.418Z",
    transform: "translate(-65.053 -445.723)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(10.358 2.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M64.783,446.013a.619.619,0,0,0,.139-.423,1.033,1.033,0,0,0-.1-.483.634.634,0,0,0-.471-.4.252.252,0,0,0-.237.259.691.691,0,0,0,.063.295,1.906,1.906,0,0,0,.236.424c.166.222.31.319.318.308s-.107-.131-.249-.355a2.2,2.2,0,0,1-.2-.415c-.065-.145-.087-.391.074-.4s.294.189.37.329a1.043,1.043,0,0,1,.114.433A2.322,2.322,0,0,1,64.783,446.013Z",
    transform: "translate(-64.114 -444.709)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(0.611 1.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M46.237,442.9c0,.022.282.017.714.137a3.082,3.082,0,0,1,2.231,2.423c.083.44.055.722.077.722a.58.58,0,0,0,.031-.2,2.6,2.6,0,0,0-.025-.541,2.989,2.989,0,0,0-2.293-2.491,2.6,2.6,0,0,0-.537-.069A.574.574,0,0,0,46.237,442.9Z",
    transform: "translate(-46.237 -442.885)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(5.008 3.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M54.3,447.643a8.067,8.067,0,0,0,2.836.467c0-.035-.638-.094-1.419-.224S54.311,447.61,54.3,447.643Z",
    transform: "translate(-54.302 -447.638)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(3.097 3.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M50.8,447.1c-.027.02.031.142.073.3s.058.29.092.293.074-.146.023-.325S50.829,447.079,50.8,447.1Z",
    transform: "translate(-50.797 -447.097)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(2.517 2.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M49.741,445.256c-.027.02.02.13.105.248s.175.2.2.178-.02-.13-.105-.247S49.767,445.237,49.741,445.256Z",
    transform: "translate(-49.733 -445.253)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    transform: "translate(1.56 1.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M47.979,444.188c0,.034.131.053.266.125s.226.164.255.146-.032-.165-.2-.252S47.974,444.157,47.979,444.188Z",
    transform: "translate(-47.979 -444.153)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(0.856 1.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M46.69,443.644c-.016.028.032.087.107.131s.15.056.167.028-.032-.087-.108-.131S46.707,443.616,46.69,443.644Z",
    transform: "translate(-46.687 -443.629)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(53.846 172.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M140.4,446.147l.365,4.055.611-.028c2.713-.151,13.787-.96,15.529-1.707,1.943-.834-6.57-1.778-6.57-1.778l-.2-1.7Z",
    transform: "translate(-140.4 -444.988)",
    fill: "#3a9cd8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(0.057 2.285)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M144.347,451.636a3.414,3.414,0,0,0-1.48-1.945,3.314,3.314,0,0,0-2.364-.456l.3,2.732Z",
    transform: "translate(-140.504 -449.179)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    transform: "translate(0.356 2.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M154.806,449.218s3,.515,2.695,1.035-11.469,1.758-16.439,1.873l-.009-.22,13.029-1.333S154.24,449.305,154.806,449.218Z",
    transform: "translate(-141.053 -449.218)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    transform: "translate(0.202 3.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M140.771,452.643a.942.942,0,0,0,.17,0l.486-.025,1.785-.121c1.506-.112,3.585-.3,5.877-.547s4.361-.527,5.856-.745l1.768-.271.479-.082a.959.959,0,0,0,.166-.037.842.842,0,0,0-.17.013l-.483.06-1.773.233c-1.5.2-3.567.457-5.857.71s-4.367.448-5.871.582l-1.782.158-.484.047A.854.854,0,0,0,140.771,452.643Z",
    transform: "translate(-140.771 -450.814)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(13.364 2.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M164.947,450.619a2.6,2.6,0,0,1,.768-1.632,1.588,1.588,0,0,0-.768,1.632Z",
    transform: "translate(-164.912 -448.985)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(10.347 1.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M159.383,449.158c.029.015.149-.168.267-.409s.189-.447.159-.462-.149.169-.267.409S159.353,449.144,159.383,449.158Z",
    transform: "translate(-159.376 -448.287)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(9.512 1.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M157.849,448.763c.025.022.167-.1.319-.268s.255-.326.23-.347-.167.1-.319.268S157.824,448.741,157.849,448.763Z",
    transform: "translate(-157.845 -448.145)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(8.913 1.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M156.747,447.581a2.23,2.23,0,1,0,.505-.111A1.156,1.156,0,0,0,156.747,447.581Z",
    transform: "translate(-156.747 -447.452)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(8.668 0.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M156.3,446.486a1.447,1.447,0,0,0,1.167-.041,41.69,41.69,0,0,1-1.167.041Z",
    transform: "translate(-156.299 -446.434)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(10.59 0.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M159.823,447.4a1.84,1.84,0,0,0,.628-.074,3.7,3.7,0,0,0,.652-.222,1.8,1.8,0,0,0,.365-.2.341.341,0,0,0,.134-.212.248.248,0,0,0-.123-.24,1.158,1.158,0,0,0-1.387.5,1.127,1.127,0,0,0-.159.442.35.35,0,0,0,0,.171,1.789,1.789,0,0,1,.227-.568,1.138,1.138,0,0,1,.5-.408.978.978,0,0,1,.754-.032c.108.063.082.184-.021.263a1.92,1.92,0,0,1-.336.19,4.451,4.451,0,0,1-.628.24C160.06,447.354,159.821,447.381,159.823,447.4Z",
    transform: "translate(-159.823 -446.378)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(9.828 0.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M159.354,447.317a.622.622,0,0,0,.024-.444,1.033,1.033,0,0,0-.222-.439.633.633,0,0,0-.558-.262.251.251,0,0,0-.161.311.689.689,0,0,0,.138.269,1.926,1.926,0,0,0,.339.347.911.911,0,0,0,.388.214c.009-.016-.137-.1-.333-.279a2.212,2.212,0,0,1-.3-.347c-.1-.123-.186-.355-.032-.4s.333.106.443.221a1.035,1.035,0,0,1,.223.389A2.29,2.29,0,0,1,159.354,447.317Z",
    transform: "translate(-158.425 -446.165)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(0.105 2.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M140.592,449.1c0,.022.278-.058.725-.054a3.082,3.082,0,0,1,2.787,1.757c.2.4.241.682.263.677a.563.563,0,0,0-.021-.2,2.614,2.614,0,0,0-.165-.515,2.991,2.991,0,0,0-2.864-1.806,2.631,2.631,0,0,0-.536.074A.582.582,0,0,0,140.592,449.1Z",
    transform: "translate(-140.592 -448.962)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(5.024 3.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M149.615,451.441a8.084,8.084,0,0,0,2.859-.29c-.007-.034-.641.076-1.429.155S149.615,451.406,149.615,451.441Z",
    transform: "translate(-149.615 -451.144)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(3.105 3.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M146.1,452.068c-.021.027.067.129.148.269s.132.265.165.259.033-.16-.062-.32S146.117,452.042,146.1,452.068Z",
    transform: "translate(-146.095 -452.063)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(2.283 3.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M144.591,450.566c-.021.026.053.12.166.212s.22.145.241.119-.053-.12-.166-.212S144.612,450.54,144.591,450.566Z",
    transform: "translate(-144.588 -450.559)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(1.207 2.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M142.615,449.964c.01.033.14.017.29.052s.261.1.284.075-.074-.151-.258-.191S142.6,449.935,142.615,449.964Z",
    transform: "translate(-142.614 -449.888)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(0.451 2.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M141.227,449.8c-.009.032.053.076.137.1s.16.015.168-.017-.053-.076-.137-.1S141.235,449.767,141.227,449.8Z",
    transform: "translate(-141.226 -449.768)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(38.397 1.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M130.362,149.367c-.782-4.172-5.391-6.49-7.191-10.334-.7-1.5-.949-3.18-1.721-4.64a7.458,7.458,0,0,0-9.1-3.3l-.287.447c1.86,3.913,3.719,6.6,5.579,10.512a13.816,13.816,0,0,1,1.484,4.281,4.678,4.678,0,0,1-1.4,4.136c-.934.775-2.208,1.007-3.215,1.684a5.242,5.242,0,0,0-2.056,4.873,8.827,8.827,0,0,0,2.424,4.9c1.2,1.315,3.1,2.442,4.683,1.625a7.168,7.168,0,0,0,1.883-1.9,24.791,24.791,0,0,1,4.368-3.366C128.656,156.2,131.011,152.828,130.362,149.367Z",
    transform: "translate(-112.065 -130.602)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(29.596 28.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(18.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(36.212 3.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M208.819,194.526c-1.044.953-6.745,5.739-6.745,5.739l-5.652-5.144c.147-.422,1.529-2.795,1.69-3.392a4.651,4.651,0,0,0,.141-1.576,7.126,7.126,0,0,0-.352-1.941c-.248-.555.308-1.122.787-.848s1.2,1.786,1.177,3.741,7.658-2.534,8.751-1.436Z",
    transform: "translate(-196.423 -187.292)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(46.247 10.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M214.828,199.52",
    transform: "translate(-214.828 -199.52)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(0 3.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M130.008,186.467l18.76,22.449,17.223-15.575,7.512,7.329s-21.62,23.788-24.918,23.62-14.5-7.577-14.5-7.577Z",
    transform: "translate(-130.008 -186.467)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(37.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M203.492,180.327a.308.308,0,0,0-.384.179l-5.1,12.855a.488.488,0,0,0,.242.624l6.055,2.886a.488.488,0,0,0,.658-.248L210.7,183.3a.489.489,0,0,0-.291-.654Z",
    transform: "translate(-197.976 -180.311)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(0.664 0.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M203.881,182.042l-4.688,11.471,6.342,2.871,4.8-12.163Z",
    transform: "translate(-199.193 -182.042)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(32.629 13.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M197.8,212.19a7.992,7.992,0,0,1-1.332-.945,39.6,39.6,0,0,1-5.638-5.493,7.928,7.928,0,0,1-.98-1.306,11.124,11.124,0,0,1,1.13,1.174c.681.739,1.634,1.747,2.73,2.816s2.13,1.993,2.886,2.655A11.158,11.158,0,0,1,197.8,212.19Z",
    transform: "translate(-189.853 -204.444)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(34.819 12.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M194.242,202.9c.035.031-.2.216-.172.614a.775.775,0,0,0,.281.562.706.706,0,0,0,1.07-.615.776.776,0,0,0-.343-.525c-.332-.222-.608-.116-.617-.162-.007-.014.048-.066.176-.1a.819.819,0,0,1,.542.085.94.94,0,0,1,.5.662.948.948,0,0,1-1.492.857.942.942,0,0,1-.319-.767.82.82,0,0,1,.2-.511C194.161,202.912,194.234,202.891,194.242,202.9Z",
    transform: "translate(-193.869 -202.666)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(17.628 25.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M162.732,234.106a2.717,2.717,0,0,1-.276-.973,8.889,8.889,0,0,1,.545-4.807,2.72,2.72,0,0,1,.487-.886,13.115,13.115,0,0,0-.756,6.666Z",
    transform: "translate(-162.339 -227.439)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875",
    transform: "translate(18.695 25.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M166.294,233.806a2.983,2.983,0,0,1-.607-.841,10.555,10.555,0,0,1-1.386-4.775,2.978,2.978,0,0,1,.062-1.035,28.132,28.132,0,0,0,.618,3.427A28.2,28.2,0,0,0,166.294,233.806Z",
    transform: "translate(-164.296 -227.154)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(39.418 3.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M205.406,185.964l-3.1,7.714,4.646,1.9,3.238-7.884Z",
    transform: "translate(-202.304 -185.964)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(40.347 9.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    d: "M.467,0H3.305a.467.467,0,0,1,.467.467v0a.467.467,0,0,1-.467.467H.467A.467.467,0,0,1,0,.467v0A.467.467,0,0,1,.467,0Z",
    transform: "translate(0.36 0) rotate(22.68)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(42.665 4.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 3.679,
    height: 0.537,
    transform: "translate(0.189 0) rotate(20.633)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(41.649 5.945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 4.069,
    height: 1.052,
    transform: "translate(0.371 0) rotate(20.634)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(41.021 7.528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 4.069,
    height: 1.052,
    transform: "translate(0.371 0) rotate(20.634)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(44.064 6.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M215.167,191.651c-.876.144-1.947.231-2.823.375a1.58,1.58,0,0,0-.708.237.543.543,0,0,0-.2.661c.14.25.485.272.772.263l1.934-.063a10.288,10.288,0,0,0-2.434.406c-.364.123-.768.365-.776.749a.71.71,0,0,0,.641.641,7.638,7.638,0,0,0,1.015.016s1.324.019,1.382.192c-.826-.006-1.919.173-2.745.246-.226.02-.329.329-.383.549a.5.5,0,0,0,.239.578.76.76,0,0,0,.326.038l3.206-.1",
    transform: "translate(-210.825 -191.651)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(0 1.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M107.87,183.967s3.9-.459,6.637,1.339c2.473,1.625,11.137,26.468,10.8,33.84s.6,20.368,2.119,25.726,2.664,51.813-9.291,73.919l-22.215-3.119,6.943-59.663-.709-54.126Z",
    transform: "translate(-95.923 -183.915)",
    fill: "#3a9cd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(0.633)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M107.121,183.967s3.9-.459,6.637,1.339c2.474,1.625,11.138,26.468,10.8,33.84s.6,20.368,2.119,25.726,2.664,51.813-9.291,73.919l-20.306-3.119,5.033-59.663-.709-54.126Z",
    transform: "translate(-97.084 -183.915)",
    fill: "#43afe9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(22.588 29.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M92.576,181.9s-12.218-1.319-8.951,16.148l3.139,18.375,19.951,12.07c2.7.727.4-12.561,4.462-18.681a7.442,7.442,0,0,0,1.521-5.071c.384-4-2.824-6.5-3.281-10.555-.5-5.866-.479-9.116-3.031-9.772L92.576,181.9",
    transform: "translate(-83.07 -181.873)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(48.852 40.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M131.554,201.891a5.489,5.489,0,0,0,0,2.575,10.436,10.436,0,0,0,1.07,2.607,22.352,22.352,0,0,1,1.557,3.151,10.038,10.038,0,0,1,.085,6.326,8.99,8.99,0,0,1-.778,1.776,2.856,2.856,0,0,1-.4.586,16.435,16.435,0,0,0,.987-2.42,10.26,10.26,0,0,0-.161-6.173,24.308,24.308,0,0,0-1.521-3.124,10.014,10.014,0,0,1-1.035-2.686,4.873,4.873,0,0,1-.032-1.943,2.864,2.864,0,0,1,.148-.509C131.516,201.944,131.544,201.888,131.554,201.891Z",
    transform: "translate(-131.24 -201.891)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(29.249 3.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M109.086,161.536c-.286-3.006-.533-6.175-.533-6.175s3.808-1.024,4.113-6.154c.291-4.892-1.189-13.411-1.189-13.411v-.431c-5.8-1.724-12.655-1.656-16.19,3.195h0l2.729,24.375a5.26,5.26,0,0,0,6.03,4.448h0A5.557,5.557,0,0,0,109.086,161.536Z",
    transform: "translate(-95.288 -134.339)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(13.618 6.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(1.275 0.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M123.894,147.922a.651.651,0,0,1-.56.715.622.622,0,0,1-.725-.518.651.651,0,0,1,.559-.715A.623.623,0,0,1,123.894,147.922Z",
    transform: "translate(-122.603 -147.395)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M122.828,146.582c-.073.093-.6-.222-1.3-.152s-1.173.469-1.257.391c-.041-.034.026-.194.233-.378a1.784,1.784,0,0,1,1-.418,1.716,1.716,0,0,1,1.041.226C122.776,146.4,122.864,146.541,122.828,146.582Z",
    transform: "translate(-120.264 -146.018)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(6.37 7.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(1.275 0.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M110.6,149.648a.651.651,0,0,1-.561.715.622.622,0,0,1-.725-.518.651.651,0,0,1,.56-.715A.623.623,0,0,1,110.6,149.648Z",
    transform: "translate(-109.31 -149.121)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M109.535,148.359c-.073.093-.6-.222-1.3-.152s-1.173.469-1.257.391c-.041-.034.025-.195.233-.379a1.784,1.784,0,0,1,1-.418,1.717,1.717,0,0,1,1.041.226C109.482,148.172,109.571,148.318,109.535,148.359Z",
    transform: "translate(-106.971 -147.795)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(11.076 7.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M116.5,153.036a4.659,4.659,0,0,1,1.112-.316c.176-.036.341-.088.359-.212a.912.912,0,0,0-.171-.516l-.66-1.3a23.375,23.375,0,0,1-1.531-3.428,23.4,23.4,0,0,1,1.8,3.3c.222.459.436.9.638,1.313a1.038,1.038,0,0,1,.161.69.449.449,0,0,1-.267.289,1.207,1.207,0,0,1-.3.071A4.538,4.538,0,0,1,116.5,153.036Z",
    transform: "translate(-115.603 -147.26)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(6.324 19.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M113.828,171.945a12.911,12.911,0,0,1-6.941-1.138s1.982,3.308,6.99,2.337Z",
    transform: "translate(-106.887 -170.807)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(9.803 14.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M115.307,160.669a1.263,1.263,0,0,0-1.172-.355,1.15,1.15,0,0,0-.75.5.731.731,0,0,0,.026.836.848.848,0,0,0,.937.141,2.657,2.657,0,0,0,.839-.619.779.779,0,0,0,.179-.226.234.234,0,0,0-.027-.26",
    transform: "translate(-113.267 -160.286)",
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(9.886 13.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M113.5,159.109c.113-.018.189.739.889,1.212s1.5.311,1.514.416c.015.046-.165.165-.5.207a1.893,1.893,0,0,1-1.259-.3,1.65,1.65,0,0,1-.7-1.021C113.384,159.305,113.45,159.109,113.5,159.109Z",
    transform: "translate(-113.42 -159.108)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(1.551 99.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M62.055,310.173,54.31,342.1s-9.241,38.235-9.531,39.243l-.293,1.192,13.017.98L80.041,312.59Z",
    transform: "translate(-44.486 -310.173)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(18.35 62.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M99.5,302.174c2.107,10.184,9.831,52.894,9.831,52.894l13.2-1.354-7.507-54.475a17.9,17.9,0,0,0-.859-4.179l-12.34-36.995L78.6,243.3c-.23.013-3.759,9.532-3.251,16.144a16.907,16.907,0,0,0,2.963,8.232c1.476,2.155,3.531,5.159,3.991,5.853C83.037,274.642,99.5,302.174,99.5,302.174Z",
    transform: "translate(-75.298 -243.304)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(0 28.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M57.8,227.381q-.956,3.45-1.573,6.979c-1.485,8.552-5.257,29.367-7.7,34.871-3.1,6.978-8.141,33.339-6.591,38.185s35.278,9.692,35.278,9.692,1.938-31.6,3.877-39.542S87.1,252.174,87.677,241.9s.388-28.106-2.908-39.155-10.875-22.652-10.875-22.652-6.476,1.785-8.683,4.354c0,0-2.7,3.3-2.75,6.449s-1.492,18.1-2.47,26.792A77.734,77.734,0,0,1,57.8,227.381Z",
    transform: "translate(-41.642 -180.094)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(32.205 6.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M114.566,246.516a.69.69,0,0,1-.019-.158c-.007-.121-.016-.273-.028-.463-.021-.427-.05-1.023-.087-1.781a56.193,56.193,0,0,0-.628-6.513,22.19,22.19,0,0,0-1.181-4.34,17,17,0,0,0-2.6-4.437c-1.122-1.438-2.448-2.829-3.734-4.358a27.443,27.443,0,0,1-1.846-2.43,14.18,14.18,0,0,1-1.434-2.809,9.176,9.176,0,0,1-.336-6.132,12.183,12.183,0,0,1,1.423-2.587,4.837,4.837,0,0,0,.565-1.256,1.947,1.947,0,0,0,.052-.646,1.388,1.388,0,0,0-.218-.586,1.946,1.946,0,0,0-1.017-.728c-.406-.157-.837-.269-1.245-.458a2.387,2.387,0,0,1-1.022-.853,3.076,3.076,0,0,1-.438-1.2,8.09,8.09,0,0,1,.063-2.38q.162-1.121.311-2.151c.4-2.724.726-4.935.954-6.489.117-.749.208-1.339.274-1.762l.078-.457a.654.654,0,0,1,.036-.154.667.667,0,0,1-.007.158l-.051.461c-.053.425-.127,1.017-.221,1.77-.207,1.556-.5,3.771-.865,6.5q-.139,1.03-.292,2.154a7.946,7.946,0,0,0-.048,2.312,2.845,2.845,0,0,0,.408,1.109,2.139,2.139,0,0,0,.924.761c.381.175.806.285,1.233.446a2.2,2.2,0,0,1,1.144.824,1.665,1.665,0,0,1,.261.7,2.218,2.218,0,0,1-.055.74,5.1,5.1,0,0,1-.591,1.331,12.031,12.031,0,0,0-1.393,2.539,8.927,8.927,0,0,0,.339,5.943,17.483,17.483,0,0,0,3.228,5.16c1.275,1.522,2.6,2.92,3.727,4.375a17.1,17.1,0,0,1,2.613,4.511,22.1,22.1,0,0,1,1.16,4.393,51.347,51.347,0,0,1,.54,6.542c.014.758.025,1.355.033,1.783,0,.191,0,.343,0,.464A.664.664,0,0,1,114.566,246.516Z",
    transform: "translate(-100.709 -191.383)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(41.399 65.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M117.934,300.171c-.011-.011.031-.088.161-.172a.915.915,0,0,1,.638-.112.9.9,0,0,1,.73.646.97.97,0,0,1-1.6.992.884.884,0,0,1-.241-.945.9.9,0,0,1,.4-.509c.136-.074.225-.073.228-.058a1.206,1.206,0,0,0-.436.621.682.682,0,0,0,.22.694.716.716,0,0,0,1.175-.73.7.7,0,0,0-.519-.515A1.258,1.258,0,0,0,117.934,300.171Z",
    transform: "translate(-117.572 -299.872)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(37.789 84.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M111.312,334.633c-.011-.011.031-.088.161-.172a.916.916,0,0,1,.638-.112.9.9,0,0,1,.73.646.97.97,0,0,1-1.6.992.884.884,0,0,1-.241-.945.9.9,0,0,1,.4-.509c.136-.074.225-.073.228-.058a1.21,1.21,0,0,0-.436.621.682.682,0,0,0,.22.694.716.716,0,0,0,1.175-.73.7.7,0,0,0-.519-.515A1.254,1.254,0,0,0,111.312,334.633Z",
    transform: "translate(-110.95 -334.334)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(17.814 60.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M94.537,291.767a1.314,1.314,0,0,1-.006.183c-.013.136-.028.312-.049.535-.053.487-.128,1.176-.224,2.053-.209,1.782-.522,4.359-1,7.532-.24,1.586-.523,3.322-.909,5.172a16.977,16.977,0,0,1-.788,2.836,2.689,2.689,0,0,1-.167.355,1.4,1.4,0,0,1-.272.312,2.75,2.75,0,0,1-.673.435,8.231,8.231,0,0,1-1.508.518,35.691,35.691,0,0,1-6.627.75,67.85,67.85,0,0,1-7.157-.085c-.1-.008-.2-.02-.3-.034a.45.45,0,0,1-.328-.239,1.739,1.739,0,0,1-.171-.619,8.191,8.191,0,0,1-.034-1.192c.027-.785.1-1.555.19-2.315.178-1.52.412-3,.656-4.432.493-2.869,1.033-5.566,1.566-8.039l.02-.089.09-.008a76.477,76.477,0,0,0,12.9-2.241c1.533-.4,2.727-.764,3.54-1.014l.942-.288c.21-.062.313-.093.309-.088a.758.758,0,0,1-.085.035l-.238.089c-.211.077-.5.19-.9.324-.806.273-2,.656-3.526,1.082a73.2,73.2,0,0,1-12.92,2.347l.11-.1c-.521,2.471-1.051,5.168-1.538,8.032-.24,1.432-.471,2.907-.647,4.418-.087.756-.16,1.521-.186,2.292a7.887,7.887,0,0,0,.033,1.148,1.5,1.5,0,0,0,.135.512c.045.069.064.092.125.1.094.013.189.024.287.032a68.752,68.752,0,0,0,7.12.09,35.84,35.84,0,0,0,6.575-.727,7.99,7.99,0,0,0,1.458-.495,1.688,1.688,0,0,0,1-.976,16.918,16.918,0,0,0,.785-2.782c.394-1.839.688-3.571.941-5.153.5-3.166.847-5.738,1.089-7.515.118-.875.211-1.56.276-2.047.032-.221.057-.4.077-.532C94.521,291.837,94.535,291.771,94.537,291.767Z",
    transform: "translate(-74.314 -291.767)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(1.741 3.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M95.639,299.06a3.622,3.622,0,0,1-.651.335c-.425.2-1.055.465-1.843.761a34.7,34.7,0,0,1-12.922,2.151c-.842-.025-1.523-.069-1.991-.123a3.67,3.67,0,0,1-.724-.106,3.6,3.6,0,0,1,.731,0c.469.02,1.148.034,1.986.032a39.7,39.7,0,0,0,12.852-2.139c.793-.27,1.431-.5,1.869-.674A3.685,3.685,0,0,1,95.639,299.06Z",
    transform: "translate(-77.508 -299.058)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(1.574 30.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(5.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M54.645,231.434s.011-.088.047-.257.094-.429.165-.748c.157-.668.384-1.632.675-2.867.6-2.487,1.511-6.075,2.692-10.494l1.957-7.22c.712-2.593,1.456-5.369,2.345-8.262a67.2,67.2,0,0,1,3.362-8.883,41.394,41.394,0,0,1,2.42-4.412,15.941,15.941,0,0,1,1.506-2.1,6.505,6.505,0,0,1,2.059-1.651,3.521,3.521,0,0,1,2.634-.2,4.543,4.543,0,0,1,2.11,1.542,9.016,9.016,0,0,1,1.517,4.794c.279,3.279.547,6.442.8,9.456.5,6.024.957,11.45,1.337,16.011s.669,8.234.877,10.8c.1,1.265.172,2.252.224,2.937.022.326.039.58.051.764s.008.261.008.261-.017-.087-.037-.259l-.079-.762c-.065-.684-.158-1.669-.278-2.932-.23-2.56-.559-6.243-.967-10.789s-.872-9.984-1.4-16.006c-.261-3.012-.535-6.174-.819-9.452a8.76,8.76,0,0,0-1.463-4.646,4.264,4.264,0,0,0-1.974-1.447,3.235,3.235,0,0,0-2.426.19,6.237,6.237,0,0,0-1.967,1.581,15.719,15.719,0,0,0-1.481,2.065,41.346,41.346,0,0,0-2.407,4.379,67.433,67.433,0,0,0-3.363,8.841c-.895,2.885-1.647,5.657-2.368,8.248l-1.99,7.21c-1.207,4.41-2.146,7.99-2.779,10.468-.313,1.229-.558,2.189-.727,2.854l-.192.742C54.675,231.35,54.645,231.434,54.645,231.434Z",
    transform: "translate(-54.645 -184.168)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(0 45.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M48.707,267.408c-.213.851-4.178,23.408-4.178,23.408l29.492.955,4.06-23.393Z",
    transform: "translate(-44.529 -267.408)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(4.389 0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M81.439,269.1a1.453,1.453,0,0,1-.266.2c-.179.125-.447.3-.8.526-.7.446-1.719,1.075-3.007,1.8s-2.842,1.569-4.612,2.41c-.891.414-1.812.854-2.831,1.222a9.875,9.875,0,0,1-3.291.48,15.43,15.43,0,0,1-6.173-1.6,22.47,22.47,0,0,1-4.371-2.84c-1.154-.934-2.024-1.761-2.62-2.335-.3-.29-.523-.516-.674-.674a1.5,1.5,0,0,1-.22-.25,1.446,1.446,0,0,1,.26.209l.71.635c.618.549,1.507,1.35,2.669,2.259a23.243,23.243,0,0,0,4.357,2.76,15.417,15.417,0,0,0,6.067,1.549,9.7,9.7,0,0,0,3.2-.46c.985-.352,1.924-.791,2.808-1.2,1.769-.825,3.327-1.644,4.626-2.348s2.333-1.307,3.047-1.724l.823-.48A1.431,1.431,0,0,1,81.439,269.1Z",
    transform: "translate(-52.578 -268.049)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(27.629 2.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M99.019,271.822c.077.014-.713,4.927-1.765,10.972s-1.968,10.937-2.045,10.924.713-4.926,1.765-10.973S98.942,271.809,99.019,271.822Z",
    transform: "translate(-95.203 -271.822)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(17.309 7.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M76.538,280.419q-.119,1.1-.236,2.2a1.89,1.89,0,0,0,.011.694.574.574,0,0,0,1.11.109,1.9,1.9,0,0,0,.157-.789l.126-2.355-.969.008",
    transform: "translate(-76.275 -280.275)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(11.69 31.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M76.616,185.449c2.394-.8,4.4,2.3,4.672,4.815a54.951,54.951,0,0,1,.165,8.7,51.159,51.159,0,0,1-4.323,16.813l24.667,3.687-.906,9.488L69.7,225.607a7.394,7.394,0,0,1-6.286-9.518c2.788-9.063,7.342-22.132,8.368-24.3C73.159,188.874,73.314,186.555,76.616,185.449Z",
    transform: "translate(-63.083 -185.32)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(5.441 13.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M73.062,237a.771.771,0,0,1,.16.014l.469.064,1.809.269c1.579.219,3.876.544,6.76.877,5.766.682,13.87,1.491,23.179,2.208l-.148.124.9-9.474,0-.014.119.154-24.66-3.714-.135-.02.041-.128c1.606-4.963,2.833-9.067,3.563-11.956.368-1.443.624-2.578.785-3.353l.18-.884c.041-.2.071-.3.071-.3s-.007.105-.038.307-.074.5-.147.89c-.14.78-.377,1.921-.726,3.371-.693,2.9-1.89,7.022-3.471,11.994l-.094-.148,24.673,3.66.132.02-.013.134v.014c-.314,3.271-.619,6.455-.908,9.474l-.013.136-.135-.011c-9.314-.732-17.416-1.576-23.18-2.307-2.883-.358-5.178-.71-6.753-.959l-1.8-.315-.465-.088A.755.755,0,0,1,73.062,237Z",
    transform: "translate(-73.062 -210.87)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(32.928 33.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M123.5,256.434a85.614,85.614,0,0,1,.911-9.819,43.024,43.024,0,0,1-.314,4.923A42.7,42.7,0,0,1,123.5,256.434Z",
    transform: "translate(-123.476 -246.615)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(35.205 34.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M128.536,249.418c0-.017.064-.043.185-.023a.688.688,0,0,1,.425.286.711.711,0,0,1,.04.778.84.84,0,0,1-.867.4.866.866,0,0,1-.654-.7.79.79,0,0,1,.259-.731c.352-.3.664-.2.646-.167.005.045-.265.039-.5.309a.6.6,0,0,0-.144.538.628.628,0,0,0,.454.469.6.6,0,0,0,.588-.262.511.511,0,0,0,.013-.535C128.8,249.474,128.526,249.46,128.536,249.418Z",
    transform: "translate(-127.652 -249.23)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(37.899 28.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(5.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0.534 2.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M143.837,242.867l1.127,11.687h5.7l1.364-11.687Z",
    transform: "translate(-143.837 -242.867)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0 1.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M143.391,240.1a2.436,2.436,0,0,0-.534,1.542h9.255a1.723,1.723,0,0,0-.534-1.542Z",
    transform: "translate(-142.857 -240.097)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(1.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M145.511,238.122l-.313,1.157,6.986.053-.461-1.222Z",
    transform: "translate(-145.198 -238.109)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(0.417 5.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M143.622,248.233c0,.109.678,5.883.678,5.883h6.963l.663-5.883Z",
    transform: "translate(-143.622 -248.233)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(0 4.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M139.04,246.31l-.179,1.955,6.743.159s0,2.274-.682,2.956c0,0,.682,1.364-.076,2.122s-1.213.531-1.213.531.3,1.516-.455,1.895-10.585-.208-10.585-.208l.6-6.326,2.2-.2A3.207,3.207,0,0,1,139.04,246.31Z",
    transform: "translate(-132.593 -246.275)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(22.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M107.747,133.1a5.006,5.006,0,0,0-2.146-2.713,3.752,3.752,0,0,0-2.283-.468l.008-.016-.014-.164c-.733-1.316-2.181-1.6-3.675-1.351s-2.965,1.342-4.295,2.051c-1.8.959-3.521,2.057-5.24,3.153a13.343,13.343,0,0,0-3.878,3.234A6.727,6.727,0,0,0,85.1,141.9c.352,1.91,1.533,3.849.833,5.661-.467,1.209-1.652,1.966-2.432,3a4.85,4.85,0,0,0-.1,5.651,11.525,11.525,0,0,0,3.122,2.439,49.785,49.785,0,0,0,5.238,3.554c1.9.93,4.3,1.235,6.046.047,1.8-1.223,2.374-3.684,2.053-5.835a26.678,26.678,0,0,0-2.192-6.127,33.853,33.853,0,0,1-2.238-8.171,5.413,5.413,0,0,1,.284-3.319,7.042,7.042,0,0,1,2.186-2.077,17.444,17.444,0,0,0,4.678-5.343,6.79,6.79,0,0,0,1.867,2.615,16.8,16.8,0,0,0,3.673,2.6A8.517,8.517,0,0,0,107.747,133.1Z",
    transform: "translate(-82.536 -128.307)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(209.601 145.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(15.95 29.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M441.722,410.072c-.364-1.444.589-2.886,1.655-3.926s2.339-1.97,2.9-3.35c.906-2.236-.278-5.144,1.257-7.005.9-1.095,2.513-1.454,3.315-2.624a6.006,6.006,0,0,0,.728-2.1,21.326,21.326,0,0,1,5.361-9.9,18.506,18.506,0,0,1-2.136,9.554,12.171,12.171,0,0,0-1.6,3.624c-.345,2.129.832,4.33.3,6.418-.612,2.388-3.308,3.974-3.45,6.436-.119,2.081,1.685,3.919,1.538,6a5.616,5.616,0,0,1-.94,2.464,8.265,8.265,0,0,1-7.584,4.416l-4.391.129Z",
    transform: "translate(-438.669 -381.176)",
    fill: "#3a9cd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(15.95 29.015)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M441.722,410.072c-.364-1.444.589-2.886,1.655-3.926s2.339-1.97,2.9-3.35c.906-2.236-.278-5.144,1.257-7.005.9-1.095,2.513-1.454,3.315-2.624a6.006,6.006,0,0,0,.728-2.1,21.326,21.326,0,0,1,5.361-9.9,18.506,18.506,0,0,1-2.136,9.554,12.171,12.171,0,0,0-1.6,3.624c-.345,2.129.832,4.33.3,6.418-.612,2.388-3.308,3.974-3.45,6.436-.119,2.081,1.685,3.919,1.538,6a5.616,5.616,0,0,1-.94,2.464,8.265,8.265,0,0,1-7.584,4.416l-4.391.129Z",
    transform: "translate(-438.669 -381.176)",
    fill: "#2f77b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(0 13.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M424.476,407.587a3.514,3.514,0,0,1-1.209-.033,7.351,7.351,0,0,1-1.425-.367,6.032,6.032,0,0,1-1.757-.975,2.454,2.454,0,0,1-.719-.97,4.542,4.542,0,0,1-.2-1.313,12.8,12.8,0,0,0-.095-1.42,3.91,3.91,0,0,0-.528-1.415,10.738,10.738,0,0,1-1.638-3.014,9.955,9.955,0,0,1,.141-3.848,8.16,8.16,0,0,0-.079-4.124c-.463-1.376-1.419-2.62-1.891-4.171-.471-1.566-.237-3.246-.329-4.905a6.505,6.505,0,0,0-.558-2.44c-.351-.779-.839-1.515-1.219-2.335a17.038,17.038,0,0,1-1.1-5.372q-.148-1.389-.3-2.807a13.727,13.727,0,0,0-.472-2.81,24.777,24.777,0,0,0-1.035-2.723,9.112,9.112,0,0,1-.5-1.422,14.363,14.363,0,0,1-.133-1.511,17.8,17.8,0,0,1,.134-3.039c.125-1.013.314-2.016.429-3.03l.02-.175.024-.2.18.092a6.788,6.788,0,0,1,2.353,2.008,10.758,10.758,0,0,1,1.437,2.685,32.968,32.968,0,0,1,1.335,5.757,15.616,15.616,0,0,0,1.773,5.319c.477.785,1.054,1.5,1.56,2.267a6.209,6.209,0,0,1,1.075,2.509c.249,1.859-.783,3.484-.58,5.13a5.687,5.687,0,0,0,.788,2.282c.394.7.859,1.357,1.3,2.013a12.9,12.9,0,0,1,1.167,2.032,6.424,6.424,0,0,1,.527,2.2c.1,1.481-.119,2.884-.019,4.211A9.693,9.693,0,0,0,424,395.287c.525,1.083,1.11,2.063,1.6,3.013a15.274,15.274,0,0,1,.658,1.4,6.88,6.88,0,0,1,.378,1.39,8.778,8.778,0,0,1,.018,2.506,6.313,6.313,0,0,1-1.274,3.188,3.04,3.04,0,0,1-.358.383,1.778,1.778,0,0,1-.29.243c-.165.119-.252.174-.252.174a5.6,5.6,0,0,0,.854-.836,6.353,6.353,0,0,0,1.209-3.167,8.693,8.693,0,0,0-.042-2.469,6.763,6.763,0,0,0-.381-1.358c-.184-.454-.413-.915-.661-1.384-.493-.942-1.085-1.918-1.622-3.008a9.856,9.856,0,0,1-1.1-3.678c-.108-1.354.1-2.763,0-4.209a6.2,6.2,0,0,0-.517-2.129,12.741,12.741,0,0,0-1.154-1.992c-.441-.652-.911-1.307-1.317-2.026a5.93,5.93,0,0,1-.824-2.377c-.2-1.753.823-3.39.569-5.116a5.952,5.952,0,0,0-1.039-2.4c-.5-.751-1.078-1.469-1.569-2.274a15.864,15.864,0,0,1-1.816-5.409,32.836,32.836,0,0,0-1.325-5.708,10.481,10.481,0,0,0-1.4-2.613,6.5,6.5,0,0,0-2.253-1.925l.2-.112-.021.177c-.116,1.027-.305,2.032-.429,3.033a17.552,17.552,0,0,0-.133,2.992,14.368,14.368,0,0,0,.126,1.465,8.848,8.848,0,0,0,.485,1.371,24.864,24.864,0,0,1,1.043,2.753,13.976,13.976,0,0,1,.478,2.857q.15,1.419.3,2.809a16.868,16.868,0,0,0,1.068,5.292c.366.8.854,1.535,1.215,2.34a6.749,6.749,0,0,1,.574,2.531c.086,1.7-.143,3.349.306,4.853s1.4,2.747,1.873,4.167a8.353,8.353,0,0,1,.07,4.227,9.806,9.806,0,0,0-.164,3.774,10.708,10.708,0,0,0,1.6,2.976,4.064,4.064,0,0,1,.536,1.471,12.689,12.689,0,0,1,.084,1.438,4.432,4.432,0,0,0,.18,1.277,2.349,2.349,0,0,0,.676.928,6.037,6.037,0,0,0,1.714.979,7.556,7.556,0,0,0,1.4.39,5.68,5.68,0,0,0,.892.092C424.371,407.583,424.476,407.587,424.476,407.587Z",
    transform: "translate(-409.415 -353.165)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(1.482 2.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M412.134,357.981a.526.526,0,0,1,.042.133l.095.4c.085.346.185.869.347,1.522s.563,1.389.9,2.3.7,1.946,1.026,3.12.618,2.474.92,3.869a16.282,16.282,0,0,0,1.381,4.295c.356.715.757,1.439,1.074,2.231a10.348,10.348,0,0,1,.618,2.523,51,51,0,0,0,.917,5.316c.86,3.6,1.679,7.034,2.424,10.158.764,3.114,1.453,5.92,2.033,8.285l1.347,5.591.352,1.524c.034.161.062.292.085.4a.5.5,0,0,1,.019.138.545.545,0,0,1-.047-.131l-.112-.391-.4-1.511-1.435-5.57-2.092-8.27-2.448-10.161a50.206,50.206,0,0,1-.914-5.338,10.136,10.136,0,0,0-.594-2.461c-.306-.771-.7-1.492-1.057-2.215a16.379,16.379,0,0,1-1.377-4.361c-.292-1.4-.569-2.7-.883-3.866s-.648-2.214-.981-3.116c-.318-.906-.7-1.653-.857-2.326s-.229-1.186-.3-1.539l-.067-.4A.5.5,0,0,1,412.134,357.981Z",
    transform: "translate(-412.132 -357.981)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(11.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M433.125,396.134c-2.858-1.72-3.651-6.9-2.437-10.006s3.323-5.94,3.665-9.259c.263-2.551-.558-5.175.05-7.666.822-3.362,4.123-5.951,4.1-9.411-.01-1.942-1.1-3.775-1.005-5.715.122-2.378,1.958-4.256,3.1-6.345,1.75-3.2,1.885-6.991,2.5-10.585s2.005-7.438,5.2-9.188c.454,3.057,1.245,5.152.969,9.288-.1,1.485-1.841,4.32-2.094,7.575-.152,1.945-.26,3.894-.39,5.841a18.747,18.747,0,0,1-.95,5.594c-.528,1.355-1.372,2.585-1.767,3.986-.742,2.635.2,5.5-.405,8.17-.51,2.263-2.089,4.2-2.423,6.5-.468,3.225,1.6,6.591.515,9.663-.539,1.524-1.8,2.744-2.168,4.32-.284,1.222.011,2.52-.246,3.748-.415,1.978-4.2,3.5-6.219,3.361",
    transform: "translate(-430.139 -327.961)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(2.985 3.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M449.986,333.512a.763.763,0,0,1-.013.173c-.017.128-.04.293-.068.5-.068.441-.146,1.088-.3,1.925s-.6,1.787-.957,2.928c-.372,1.138-.744,2.45-1.074,3.921s-.618,3.1-.915,4.847a20.349,20.349,0,0,1-1.5,5.478c-.408.914-.864,1.829-1.208,2.8a12.611,12.611,0,0,0-.622,3.095,62.53,62.53,0,0,1-.879,6.675L439.9,378.6l-2.193,10.379c-.632,2.938-1.144,5.322-1.5,6.992-.18.81-.322,1.446-.423,1.9l-.117.492a.793.793,0,0,1-.05.166.75.75,0,0,1,.021-.172c.022-.127.052-.291.089-.5l.371-1.909c.338-1.674.82-4.065,1.414-7.011l2.134-10.392c.776-3.917,1.629-8.222,2.525-12.74a63.186,63.186,0,0,0,.882-6.653,12.843,12.843,0,0,1,.643-3.157c.355-1,.817-1.915,1.225-2.822a20.23,20.23,0,0,0,1.508-5.412c.308-1.747.6-3.379.953-4.852s.73-2.788,1.119-3.926c.371-1.145.823-2.082,1-2.9s.265-1.475.351-1.91c.04-.206.071-.37.1-.5A.779.779,0,0,1,449.986,333.512Z",
    transform: "translate(-435.613 -333.512)",
    fill: "#263238"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group2.505619c5c9839341366be0e99ae362a6.svg";
export { ForwardRef as ReactComponent };